import React, {
  createContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { CHATBOT_WSS_URL } from './global';
import { testResponse } from "./shadcnComponents/assistant-ui/testData";
export const ChatbotWebSocketContext = createContext(null);

export function ChatbotWebSocketProvider({ children }) {
  const socketRef = useRef(null);
  const handlersRef = useRef(new Set());
  const [connected, setConnected] = useState(false);
  const [newConnection, setNewConnection] = useState(false)
  const [lastMessage, setLastMessage] = useState(null);

  useEffect(() => {
    if (newConnection) {
      const socket = new WebSocket(CHATBOT_WSS_URL);
      socketRef.current = socket;

      socket.onopen = () => {
        setConnected(true);
        console.info("WebSocket connected");
      };

      socket.onclose = () => {
        setConnected(false);
        console.info("WebSocket disconnected");
      };

      socket.onerror = (err) => {
        console.error("WebSocket error", err);
      };

      socket.onmessage = (event) => {
        let data = event.data;

        // Try to parse JSON, fallback to raw
        try {
          data = JSON.parse(event.data);
        } catch (e) { console.error(e) }

        setLastMessage(data);

        // Notify all subscribers
        handlersRef.current.forEach((handler) => {
          try {
            handler(data, event);
          } catch (err) {
            console.error("WebSocket handler error", err);
          }
        });
      };

      return () => {
        socket.close();
        handlersRef.current.clear();
      };
    } else {
      if (connected) {
        setConnected(false)
      }
    }
  }, [newConnection]);

  useEffect(() => {
    if (!connected && socketRef.current != null) {
      socketRef.current.close()
      socketRef.current = null
    }
  }, [connected])

  const sendMessage = useCallback((data) => {
    // TODO Reset messaging process
    setLastMessage(testResponse);
    // const socket = socketRef.current;
    // Open socket if closed
    // if (!socket || socket.readyState !== WebSocket.OPEN) {
    //   console.warn("WebSocket not connected");
    //   return;
    // }
    // const payload = typeof data === "string" ? data : JSON.stringify(data);
    // socket.send(payload);
  }, []);

  function connect() {
    setNewConnection(true)
  }

  function disconnect() {
    setNewConnection(false)
  }

  return (
    <ChatbotWebSocketContext.Provider
      value={{
        socket: socketRef.current,
        connected,
        lastMessage,
        sendMessage,
        connect,
        disconnect
      }}
    >
      {children}
    </ChatbotWebSocketContext.Provider>
  );
}
